import VueTheMask from 'vue-the-mask';

function WxMaskPlugin(Vue: any) {
    Vue.use(VueTheMask);
}

export { WxMaskPlugin };
